import React from 'react';
import { Alert, Button, Heading, Loader } from 'arag-ui-lib';
import { DOTS, ERROR, HEADING_3, MEDIUM, PRIMARY, QUATERNARY, RIGHT } from '../../helpers/constants';
import CONTENT_STRINGS from '../../helpers/contentStrings';

const ApplyPigConfirmationModal = (props) => {
    const { applyingPig, _applyPig, handleCloseApplyPigModal, badResponseApplyPig } = props;
    return (
        <div>
            <Heading
                variant={HEADING_3}
                title={CONTENT_STRINGS.APPLY_PIG_CONFIRM_MESSAGE}
                headingTestId={'apply-pig-confirmation-heading'}
            />
            <div className="row">
                {
                    applyingPig
                    ?
                        <div className={"col-sm-12"}>
                            <Loader variant={DOTS} dotSize={MEDIUM} />
                        </div>
                    :
                        <div className={"col-sm-12"} style={{display: 'flex', gap: '15px'}}>
                            <Button
                                label={CONTENT_STRINGS.YES}
                                variant={PRIMARY}
                                arrowDirection={RIGHT}
                                onClick={_applyPig}
                                buttonTestId={'apply-pig-confirm-yes'}
                            />
                            <Button
                                label={CONTENT_STRINGS.NO}
                                variant={QUATERNARY}
                                arrowDirection={RIGHT}
                                onClick={handleCloseApplyPigModal}
                                buttonTestId={'apply-pig-confirm-no'}
                            />
                        </div>
                }
                {
                    badResponseApplyPig
                    ?
                        <div className="col-sm-12">
                            <Alert variant={ERROR} label={badResponseApplyPig} />
                        </div>
                    :
                        null
                }
            </div>
        </div>
    );
};

export default ApplyPigConfirmationModal;
